import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelpLinkService {
  public HelpNowLink: string;

  setHelpLink(): void {
    this.HelpNowLink = 'https://ayuda.bind.com.mx';
  }
}
